import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { environment } from '@environment';

import { ApiService } from '../services/api.service';

export interface SignatureValidationResponse {
  valid: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SignatureService {
  private readonly resourceUrl = '/v1/signature';

  constructor(private apiService: ApiService) {}

  public validateSignature(
    data: string,
    signature: string
  ): Observable<SignatureValidationResponse> {
    const headers = {
      'X-API-Key': environment.fund.signatureApiKey || '',
    };

    const body = {
      data,
      signature,
    };

    return this.apiService.postWithHeaders(
      `${this.resourceUrl}/validate`,
      body,
      headers
    ) as Observable<SignatureValidationResponse>;
  }
}
